import * as React from 'react';


type AuthContextValue = {
	isAuthorized: boolean;
	ticketUID: string;
	loginPath: string;
}

type AuthProviderProps = {
	value: AuthContextValue;
}

type AuthConsumerProps = {
	children: (value: AuthContextValue) => React.ReactNode;
}

const AuthContext = React.createContext<AuthContextValue>({
	isAuthorized: false,
	ticketUID: null,
	loginPath: null,
});

const useAuthContext = () => React.useContext(AuthContext);

const AuthProvider: React.SFC<AuthProviderProps> = ({ value, children }) => {
	return (
		<AuthContext.Provider value={value}>
			{children}
		</AuthContext.Provider>
	);
}

const AuthConsumer: React.SFC<AuthConsumerProps> = ({ children }) => {
	return (
		<AuthContext.Consumer>
			{value => children(value)}
		</AuthContext.Consumer>
	);
}

export {
	AuthContext,
	useAuthContext,
	AuthProvider,
	AuthConsumer
}
